import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SubscriberService } from 'src/app/services/subscriberService/subscriber.service';
import { UserService } from 'src/app/services/userService/user.service';


@Component({
  selector: 'app-update-subscriber-info',
  templateUrl: './update-subscriber-info.component.html',
  styleUrls: ['./update-subscriber-info.component.less']
})
export class UpdateSubscriberInfoComponent implements OnInit {
  @Input() data;
  @Input() dialogRef;
  @Output() onUpdate = new EventEmitter();
  subscriberGroup: FormGroup;

  constructor(private formBuilder: FormBuilder, private subscriberService: SubscriberService, private userService: UserService) {
    const letterRegex = /^[a-zA-Zά-ωΆ-ώα-ωΑ-Ω\s]*$/; // Letters and space
    this.subscriberGroup = this.formBuilder.group({
      firstName: ['', [Validators.required, Validators.pattern(letterRegex)]],
      lastName: ['', [Validators.required, Validators.pattern(letterRegex)]],
      address: ['', [Validators.required, Validators.pattern("^[A-Za-zά-ωΆ-ώα-ωΑ-Ω0-9 \s]*[A-Za-zά-ωΆ-ώα-ωΑ-Ω0-9][A-Za-zά-ωΆ-ώα-ωΑ-Ω0-9 \s]*$")]],
      addressNum: ['', [Validators.required, Validators.pattern("^[123456789][0-9]{0,2}")]], // 1 to 3 digits and shouldn't start with 0 
      city: ['', [Validators.required, Validators.pattern(letterRegex)]],
      postalCode: ['', [Validators.required, Validators.pattern("^[12345678][0-9]{4}$")]] // Greek postal code must be 5 digits long and shouldn't start with 0 or 9.
    });
  }

  ngOnInit(): void {
    this.getData(false);
  }

  /** Get data and setup the proper fields */
  getData(isUpdate) {
    // Adress format = City -- Street -- StreetNum -- PostalCode
    this.userService.getUserInfo().then((resp: any) => {
      this.userService.setSubscriber(resp?.data?.subscriber);
      const subscriber = resp?.data?.subscriber;
      this.subscriberGroup.patchValue({
        firstName: subscriber?.firstName,
        lastName: subscriber?.lastName,
        address: subscriber?.address ? subscriber?.address.split("--")[1] : "",
        addressNum: subscriber?.address ? subscriber?.address.split("--")[2] : "",
        city: subscriber?.address ? subscriber?.address.split("--")[0] : "",
        postalCode: subscriber?.address ? subscriber?.address.split("--")[3] : ""
      });

      if (isUpdate) {
        this.onUpdate.emit();

        // In case of not using it in dialog move to my account
        if (!this.dialogRef) {
          location.hash = "#/account";
        }
      }
    });
  }

  /** Update subscriber info  */
  save() {
    const address = this.subscriberGroup.controls.city.value + "--" + this.subscriberGroup.controls.address.value + "--" + this.subscriberGroup.controls.addressNum.value + "--" + this.subscriberGroup.controls.postalCode.value;
    this.subscriberService.updateSubscriber({
      firstName: this.subscriberGroup.controls.firstName.value,
      lastName: this.subscriberGroup.controls.lastName.value,
      address: address,
    }).then((resp: any) => {
      this.getData(true);
    });
  }
}